import {FC} from 'react'
import {WithChildren} from '../../_metronic/helpers'
import {ConfigProvider, theme} from 'antd'

const AntdThemeProvider: FC<WithChildren> = ({children}) => {
  // const messages = allMessages[locale]

  const themeMode = localStorage ? localStorage.getItem('kt_theme_mode_value') : 'light'

  const isDark = themeMode == 'dark'

  const darkModeColors = {
    input: {
      bgColor: '#1b1b29',
      borderColor: '#1b1b29',
      borderHoverColor: '#1b1b29',
      color: '#92929F',
    },
    modal: {
      bgColor: '#1e1e2d',
    },
    datePicker: {
      bgColor: '#1b1b29',
      borderColor: '#1b1b29',
      borderHoverColor: '#1b1b29',
      color: '#92929F',
    },
    checkBox: {
      bgColor: '#1b1b29',
      borderColor: '#1b1b29',
      borderHoverColor: '#1b1b29',
    },
    button: {
      bgColor: '#323248',
      color: '#7E8299',
      borderColor: '#323248',
      borderHoverColor: '#323248',
    },
    card: {
      bgColor: '#1e1e2d',
    },
    select: {
      bgColor: '#1b1b29',
      borderColor: '#1b1b29',
      borderHoverColor: '#1b1b29',
      color: '#92929F',
    },
    inputNumber: {
      bgColor: '#1b1b29',
      borderColor: '#1b1b29',
      borderHoverColor: '#1b1b29',
      color: '#92929F',
    },
  }

  const defaultModeColors = {
    input: {
      bgColor: '#F4F4F4',
      borderColor: '#F4F4F4',
      borderHoverColor: '#F4F4F4',
      color: '#5E6278',
    },
    modal: {
      bgColor: '#fff',
    },
    datePicker: {
      bgColor: '#F4F4F4',
      borderColor: '#F4F4F4',
      borderHoverColor: '#F4F4F4',
      color: '#5E6278',
    },
    checkBox: {
      bgColor: '#F4F4F4',
      borderColor: '#F4F4F4',
      borderHoverColor: '#F4F4F4',
    },
    button: {
      bgColor: '#F4F4F4',
      color: '#5E6278',
      borderColor: '#F4F4F4',
      borderHoverColor: '#F4F4F4',
    },
    card: {
      bgColor: '#fff',
    },
    select: {
      bgColor: '#F4F4F4',
      borderColor: '#F4F4F4',
      borderHoverColor: '#F4F4F4',
      color: '#5E6278',
    },
  }

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        components: {
          Input: {
            colorBgContainer: isDark
              ? darkModeColors.input.bgColor
              : defaultModeColors.input.bgColor,
            colorPrimaryHover: isDark
              ? darkModeColors.input.borderHoverColor
              : defaultModeColors.input.borderHoverColor,
            colorBorder: isDark
              ? darkModeColors.input.borderColor
              : defaultModeColors.input.borderColor,
            colorText: isDark ? darkModeColors.input.color : defaultModeColors.input.color,
          },
          InputNumber: {
            colorBgContainer: isDark
              ? darkModeColors.input.bgColor
              : defaultModeColors.input.bgColor,
            colorPrimaryHover: isDark
              ? darkModeColors.input.borderHoverColor
              : defaultModeColors.input.borderHoverColor,
            colorBorder: isDark
              ? darkModeColors.input.borderColor
              : defaultModeColors.input.borderColor,
            colorText: isDark ? darkModeColors.input.color : defaultModeColors.input.color,
          },
          Modal: {
            contentBg: isDark ? darkModeColors.modal.bgColor : defaultModeColors.modal.bgColor,
          },
          DatePicker: {
            colorBgContainer: isDark
              ? darkModeColors.input.bgColor
              : defaultModeColors.input.bgColor,
            colorPrimaryHover: isDark
              ? darkModeColors.input.borderHoverColor
              : defaultModeColors.input.borderHoverColor,
            colorBorder: isDark
              ? darkModeColors.input.borderColor
              : defaultModeColors.input.borderColor,
            colorText: isDark ? darkModeColors.input.color : defaultModeColors.input.color,
            colorBgElevated: isDark
              ? darkModeColors.input.bgColor
              : defaultModeColors.input.bgColor,
          },
          Checkbox: {
            colorBgContainer: isDark
              ? darkModeColors.checkBox.bgColor
              : defaultModeColors.checkBox.bgColor,
          },
          Button: {
            colorBgContainer: isDark
              ? darkModeColors.button.bgColor
              : defaultModeColors.button.bgColor,
          },
          Card: {
            colorBgContainer: isDark ? darkModeColors.card.bgColor : defaultModeColors.card.bgColor,
          },
          Select: {
            colorBgContainer: isDark
              ? darkModeColors.select.bgColor
              : defaultModeColors.select.bgColor,
            colorPrimaryHover: isDark
              ? darkModeColors.select.borderHoverColor
              : defaultModeColors.select.borderHoverColor,
            colorBorder: isDark
              ? darkModeColors.select.borderColor
              : defaultModeColors.select.borderColor,
            colorText: isDark ? darkModeColors.select.color : defaultModeColors.select.color,
            colorBgElevated: isDark
              ? darkModeColors.select.bgColor
              : defaultModeColors.select.bgColor,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export {AntdThemeProvider}
